module.exports = __webpack_public_path__ + "media/img/about/main-banner-desktop-9b8b68f51d73cd033cfb55bdf9129b63.webp";